import React, { useMemo, useRef } from "react";
import { NumberOrderApi, NumberOrderOrganizationInfoApi } from "../../../../../services/Api/Public/types";
import { getNumberSystemFontSize } from "../utils";
import NumberSystemCard from "./NumberSystemCard";

interface Props {
	items: NumberOrderApi[];
	organizationInfo: NumberOrderOrganizationInfoApi | undefined;
}

const NumberSystemSection = ({ items, organizationInfo }: Props) => {
	const parentRef = useRef<HTMLDivElement>(null);
	const fontSize = getNumberSystemFontSize(organizationInfo);

	// Calculate dynamic grid dimensions based on font size
	const gridStyle = useMemo(() => {
		// Default font size is 64px
		// Base values: width: 163px, height: 135px for font size 64px

		// Calculate width and height dynamically based on font size
		// For font size 64px: width = 64 * 2.55 = 163.2px, height = 64 * 2.1 = 134.4px
		// This maintains the same ratio for all font sizes
		const widthRatio = 2.55; // 163/64 ≈ 2.55
		const heightRatio = 2.1; // 135/64 ≈ 2.1

		// Add a small padding to ensure text fits within the card
		const padding = fontSize * 0.2;

		const cardWidth = fontSize * widthRatio + padding;
		const cardHeight = fontSize * heightRatio + padding;

		return {
			gridTemplateRows: `repeat(auto-fill, ${cardHeight}px)`,
			gridAutoColumns: `${cardWidth}px`,
		};
	}, [fontSize]);

	return (
		<div className="number-system-section" ref={parentRef} style={gridStyle}>
			{items.map((item, index) => (
				<NumberSystemCard
					key={`${item.id}-${index}`}
					item={item}
					parentRef={parentRef}
					organizationInfo={organizationInfo}
				/>
			))}
		</div>
	);
};

export default NumberSystemSection;
